import { Plus, Trash2, ChevronUp, ChevronDown } from "lucide-react";

const inp = "w-full px-3 py-2 bg-white border border-[#E5E5E2] rounded-sm text-sm focus:ring-2 focus:ring-[#F7941D] focus:outline-none";

export function FaqEditor({ faqs, onChange }) {
  const list = faqs || [];
  const update = (i, k, v) => onChange(list.map((f, idx) => (idx === i ? { ...f, [k]: v } : f)));
  const move = (i, d) => {
    const arr = [...list];
    [arr[i], arr[i + d]] = [arr[i + d], arr[i]];
    onChange(arr);
  };
  return (
    <div data-testid="faq-editor">
      <div className="flex items-center justify-between mb-1">
        <span className="text-[11px] tracking-[0.12em] uppercase font-semibold text-[#575755]">Frequently Asked Questions</span>
        <button type="button" data-testid="faq-add" onClick={() => onChange([...list, { question: "", answer: "" }])} className="inline-flex items-center gap-1 text-xs font-semibold text-[#F7941D] hover:underline"><Plus className="w-3.5 h-3.5" /> Add question</button>
      </div>
      <p className="text-xs text-[#8a8a86] mb-3">Shown on your public page and given to Google and AI assistants as FAQ data. Questions without an answer aren't saved.</p>
      <div className="space-y-3">
        {list.length === 0 && <p className="text-xs text-[#b3b0a9] italic">No questions yet — try "What areas do you serve?" or "How do I get started buying a home?"</p>}
        {list.map((f, i) => (
          <div key={i} data-testid={`faq-item-${i}`} className="border border-[#E5E5E2] rounded-sm p-3 space-y-2">
            <div className="flex items-center gap-2">
              <input data-testid={`faq-question-${i}`} className={`${inp} flex-1`} value={f.question || ""} onChange={(e) => update(i, "question", e.target.value)} placeholder="Question" />
              <button type="button" data-testid={`faq-up-${i}`} disabled={i === 0} onClick={() => move(i, -1)} className="p-1.5 text-[#8a8a86] hover:text-[#1F3C88] disabled:opacity-30"><ChevronUp className="w-4 h-4" /></button>
              <button type="button" data-testid={`faq-down-${i}`} disabled={i === list.length - 1} onClick={() => move(i, 1)} className="p-1.5 text-[#8a8a86] hover:text-[#1F3C88] disabled:opacity-30"><ChevronDown className="w-4 h-4" /></button>
              <button type="button" data-testid={`faq-remove-${i}`} onClick={() => onChange(list.filter((_, idx) => idx !== i))} className="p-2 rounded-sm text-[#992B2B] hover:bg-[#F6E4E4]"><Trash2 className="w-4 h-4" /></button>
            </div>
            <textarea data-testid={`faq-answer-${i}`} rows={3} className={inp} value={f.answer || ""} onChange={(e) => update(i, "answer", e.target.value)} placeholder="Answer" />
          </div>
        ))}
      </div>
    </div>
  );
}
